import React from "react";
import Moment from 'react-moment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import EventIcon from '@material-ui/icons/Event';
import 'moment/locale/es';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Typography } from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';


const useStyles = makeStyles((theme) => ({
  main: {
    width: '100%',  
    //backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2)   
  },
  mensaje: {
    width: '100%',  
    paddingTop: '8px',
    paddingLeft: '10px', 
    paddingRight: '10px', 
  },
  lista: {
    width: '100%',  
    //backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(3)   
  },  
  skeleton:{
    width: '100%'  
  },
  progress:{    
    display: 'flex',
    justifyContent: 'center'
  }
}));



export default function ListaHorarios(props) {
  const classes = useStyles(); 
 
  return (
    <div className={classes.main}>    
      <ExistenHorarios />        
    </div>
  );

  function MostrarError(props) {
    return (
    <div className={classes.main}>
     <Alert variant="filled" severity="error">
        {props.error}
      </Alert>
    </div>
  )}


  function LoadingHorarios(props) {
    return (
    <div className={classes.progress}>
     <CircularProgress className={classes.progress} />
    </div>
  )}
  
  function MostrarHorarios(props) {    
    return (
    <div>
      <Typography  className={classes.mensaje} variant="body1">
        Las próximas fechas de depósito para su zona son:
      </Typography> 
      <List component="nav" aria-label="secondary mailbox folders">
        {props.horarios.proximasRecogidas.map((deposito,index) =>
          <Horario deposito={deposito} key={index}/>            
        )}
      </List>            
    </div>
  )}

  function Horario(props){

    return (
      <div>
        <Divider />
        <ListItem>
          <ListItemIcon>
            <EventIcon />
          </ListItemIcon>
          <ListItemText>
            <Moment locale="es" format="dddd DD [de] MMM">
            {props.deposito}
            </Moment> de 20:00 a 23:59
          </ListItemText>
        </ListItem>      
      </div>
    )}
  
  function ExistenHorarios() {   
    if(props.estado === 'loading'){
      return <LoadingHorarios  props={props}/>;
    }
    else if(props.estado === 'ERROR'){
      return <MostrarError error={props.error}/>
    } 
    else if(props.estado === 'OK'){
      return(
      <Paper elevation={3} className={classes.main}>
        <MostrarHorarios horarios={props.horarios}/>
      </Paper>)
    }
  }


}   



